import { evaluate } from '../../../node_modules/.pnpm/mathjs@15.1.1/node_modules/mathjs/lib/esm/entry/impureFunctionsAny.generated.js';

const ValidatorUtils = {
  cardinalRegex: /^((-?(?:\d{1,3}(?:,\d{3})*|\d+)(?:\.\d+)?)(?:\s*-\s*))?(-?(?:\d{1,3}(?:,\d{3})*|\d+)(?:\.\d+)?)$/,
  digitsRegex: /^(\d+)(?:\s*-\s*\d+)*$/,
  telephoneRegex: /^((\(\+?\d+\))+|\+?\d+)(?:\s*[-\u8F6C\u5206\u673A\u53F7]*\s*\d+)*$/u,
  nameRegex: /^\S+$/,
  addressRegex: /^\S+$/,
  idRegex: /^[a-zA-Z0-9_]+$/,
  charactersRegex: /^\S+$/,
  punctuationRegex: /^[!"#$%&'()*+,\-./:;<=>?@[\]^_`{|}~\u3000-\u303F\uFF00-\uFFEF\u2010-\u2017\u2018-\u201F]+$/u,
  dateRegex: /^([a-zA-Z0-9]+|\d+).*$/,
  timeRegex: /^(\d|\u4E0A\u5348|\u4E0B\u5348)[a-zA-Z0-9.-~:\u4E0A\u4E0B\u5348\u70B9\u5206\u6BEB\u79D2\s]*[a-zA-Z0-9.]$/u,
  currencyRegex: /^(Fr|kr|£|€|(US|CA|AU|SG|HK|C|A)?\$|CN?¥|CNY|RMB|AUD|CAD|CHF|DKK|EUR|GBP|HKD|JPY|NOK|SEK|SGD|USD)?\s*((?:\d{1,3}(?:,\d{3})*|\d+)(?:\.\d+)?\s*(thousand|million|billion|trillion|(M|m|B|b)il|(B|b|T|t)n|K|k|M|m|MM)?\s*(CN(¥|Y)|RMB|AUD|CAD|CHF|DKK|EUR|GBP|HKD|JPY|NOK|SEK|SGD|USD)?)$/,
  measureRegex: /^\S+$/,
  isCardinal(text) {
    const testResult = this.cardinalRegex.test(text);
    if (testResult) {
      return true;
    } else {
      try {
        const cleanText = text.replace(/,?\.?\s?/g, "");
        const evaluateResult = evaluate(cleanText);
        return typeof evaluateResult === "number" && !isNaN(evaluateResult);
      } catch (error) {
        return false;
      }
    }
  },
  isDigits(text) {
    return this.digitsRegex.test(text);
  },
  isTelephone(text) {
    return this.telephoneRegex.test(text);
  },
  isName(text) {
    return this.nameRegex.test(text);
  },
  isAddress(text) {
    return this.addressRegex.test(text);
  },
  isId(text) {
    return this.idRegex.test(text);
  },
  isCharacters(text) {
    return this.charactersRegex.test(text);
  },
  isPunctuation(text) {
    return this.punctuationRegex.test(text);
  },
  isDate(text) {
    return this.dateRegex.test(text);
  },
  isTime(text) {
    return this.timeRegex.test(text);
  },
  isCurrency(text) {
    return this.currencyRegex.test(text);
  },
  isMeasure(text) {
    return this.measureRegex.test(text);
  }
};

export { ValidatorUtils };
//# sourceMappingURL=validator-utils.js.map
